import { Directive, ElementRef, HostListener, Input } from '@angular/core';
import { ReportsDetailsService } from '../reports-details.service';

@Directive({
  selector: '[giqShowReportDetails]',
  standalone: false,
})
export class ShowReportDetailsDirective {
  @Input() giqShowReportDetails?: string;

  constructor(
    private elementRef: ElementRef,
    private reportDetailsService: ReportsDetailsService
  ) {}

  @HostListener('click', ['$event'])
  public show(event: Event): void {
    this.reportDetailsService.showReportDetailsFor(
      this.giqShowReportDetails,
      this.elementRef
    );
    event.stopPropagation();
  }
}
